require('./bootstrap');

require('alpinejs');
require('bootstrap-slider');


$(function() {
	$('#go-to-menu').change(function() {
		const url = $(this).val();
		console.log('fff', url);
		if (url.length > 0) {
			window.location.href = url;
		}
	});
});